import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

const HeaderTop = () => {
    const location = useLocation();

    useEffect(() => {
        const scriptUrls = [
            "https://stoneskill.com/assets/js/main.js?v=5.3",
            "https://stoneskill.com/assets/js/shop.js?v=5.3"
        ];

        const addedScripts = [];

        const timeoutId = setTimeout(() => {
            scriptUrls.forEach(url => {
                if (!document.querySelector(`script[src="${url}"]`)) {
                    const script = document.createElement("script");
                    script.src = url;
                    script.async = true;
                    script.onload = () => console.log(`${url} loaded successfully`);
                    document.body.appendChild(script);
                    addedScripts.push(script);
                }
            });
        }, 1000);

        return () => {
            clearTimeout(timeoutId);
            addedScripts.forEach(script => {
                if (document.body.contains(script)) {
                    document.body.removeChild(script);
                }
            });
        };
    }, [location.pathname]);
    return (
        <>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-xl-3 col-lg-4">
                        <div className="header-info">
                            <ul>
                                <li>
                                    <Link to={'/MyAccount'}>MyAccount</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-4">
                        <div className="text-center">
                            <div id="news-flash" className="d-inline-block">
                                <ul style={{ color: "#9E423E" }}>
                                    <li>A solid, natural mineral or rock with varied textures and colors.</li>
                                    <li>A hard, durable substance formed by geology.</li>
                                    <li>A timeless material used for construction, art, and decoration.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4">
                        <div className="header-info header-info-right">
                            <ul>
                                <li><Link to="/WishList">Wishlist</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HeaderTop